document.addEventListener('click', function (e) {
  const link = e.target.closest('a');

  // 如果点击的不是链接则跳过
  if (!link) return;

  // 只处理站内或允许的链接
  if (link.href && !link.href.startsWith('javascript:')) {
    // 阻止原始新窗口行为
    link.removeAttribute('target');
    link.target = '_self';
  }
}, true); // ✅ 使用捕获阶段监听，优先级最高